import React, { useEffect } from 'react';
import { Button, Modal } from 'semantic-ui-react';
import weddingRequestService from '../../../services/api/weddingRequestService';
import NewWeddingRequestFacilitator from './newWeddingFacilitator';
import styled from '@emotion/styled';
import Swal from 'sweetalert2';
import { TableContainerComponent } from 'src/assets/styles/components/Table';
import { chPerm } from 'src/components/helpers';

const Table = styled.div`
  table {
    width: 100%;
    border-collapse: collapse;
    margin: 15px 0;
  }
  th {
    background-color: #f2f2f2;
    color: #333;
    font-weight: 400;
    padding: 10px;
  }
  td {
    padding: 10px;
    border-bottom: 1px solid #f2f2f2;
  }
  tr:hover {
    background-color: #f9f9f9;
  }
`;

const WeddingRequestFacilitators = (props) => {
  const { allWeddingFacilitators, set_allWeddingFacilitators } = props;
  const [open, setOpen] = React.useState(false);
  const [openNewFacilitator, setOpenNewFacilitator] = React.useState(false);
  const [loading, set_loading] = React.useState(false);

  useEffect(() => {
    getInfo();
  }, []);

  function getInfo() {
    set_loading(true);
    weddingRequestService
      .getAllWeddingFacilitators()
      .then((response) => {
        if (response.data.success) {
          set_loading(false);
          set_allWeddingFacilitators(response.data.allWeddingFacilitators);
        } else {
          set_loading(null);
        }
      })
      .catch((error) => {
        set_loading(false);
      });
  }

  const handleDelete = (guest_id, role) => {
    Swal.fire({
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Eliminar',
      showCancelButton: true,
      title: `¿Está seguro que quieres eliminar este facilitador?`,
    }).then(async (result) => {
      if (result.value) {
        set_loading(true);
        weddingRequestService
          .SDeleteWeddingFacilitator({ guest_id, role })
          .then((response) => {
            if (response.data.success) {
              set_loading(false);
              getInfo();
            }
          })
          .catch((error) => {
            set_loading(false);
            if (error.response) Swal.fire(error.response.data.message);
          });
      }
    });
  };

  const facilitatorsList = (role) => {
    const filteredFacilitators = allWeddingFacilitators.filter(
      (facilitator) => facilitator.role === role
    );
    return (
      <TableContainerComponent>
        <Table>
          {filteredFacilitators.length > 0 ? (
            <table>
              <thead>
                <tr>
                  <th>Nombre</th>
                  {chPerm(['solicitudes_matrimonio_admin']) && <th>Acciones</th>}
                </tr>
              </thead>
              <tbody>
                {filteredFacilitators.map((facilitator, index) => (
                  <tr key={index}>
                    <td>
                      {facilitator?.Guest.name} {facilitator?.Guest.lastName}
                    </td>
                    {chPerm(['solicitudes_matrimonio_admin']) && (
                      <td>
                        <Button
                          size="tiny"
                          loading={loading}
                          onClick={() => handleDelete(facilitator?.Guest.id, facilitator?.role)}
                          color="red"
                        >
                          Eliminar
                        </Button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p>No se encontraron personas asignadas a este rol.</p>
          )}
        </Table>
      </TableContainerComponent>
    );
  };

  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      trigger={<Button>Pastores y Facilitadores</Button>}
    >
      <Modal.Header>Pastores y Facilitadores de matrimonio</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          {chPerm(['solicitudes_matrimonio_admin']) && (
            <Button onClick={() => setOpenNewFacilitator(true)}>Crear Nuevo</Button>
          )}
          {openNewFacilitator && (
            <NewWeddingRequestFacilitator
              open={openNewFacilitator}
              setOpen={setOpenNewFacilitator}
              getInfo={getInfo}
            />
          )}
          <h2>Pastores</h2>
          {facilitatorsList('pastor')}
          <h2>Facilitadores</h2>
          {facilitatorsList('facilitator')}
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button disabled={loading} loading={loading} onClick={() => setOpen(false)}>
          Cerrar
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default WeddingRequestFacilitators;
